module.exports = __webpack_public_path__ + "static/media/case_08.00955b24.jpg";